import { render } from "./TextEditableComponent.vue?vue&type=template&id=4f603df3&scoped=true&ts=true"
import script from "./TextEditableComponent.vue?vue&type=script&lang=ts"
export * from "./TextEditableComponent.vue?vue&type=script&lang=ts"

import "./TextEditableComponent.vue?vue&type=style&index=0&id=4f603df3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f603df3"]])

export default __exports__